import { Title } from '@angular/platform-browser';

import { HasTitle } from 'app/has-title';
import { AIToolService } from './aitool.service';
import { ContextBridgeService } from './context-bridge.service';

export interface AIToolInputField {
  type: any;
  name: string;
  description: string;
  required?: boolean;
}

export interface AITool {
  name: string;
  label: string;
  description: string;
  properties?: AIToolInputField[];
  callback: (...args: any[]) => object;
}

export abstract class HasTitleAndAITools extends HasTitle {
  private dataSubject: any;

  constructor(
    protected titleService: Title,
    protected aiToolService: AIToolService,
    protected bridgeService: ContextBridgeService
  ) {
    super(titleService);
  }

  onToolInit(): void {
    // Register tools and AI context
    this.buildAITools().forEach((t: AITool) => this.aiToolService.addTool(t));
    this.dataSubject = this.bridgeService.registerComponent();

    // Subscribe to notifications from the service
    this.bridgeService.onNotify().subscribe(() => {
      // When notified, push the updated data to the service
      const updatedData = this.buildAIContext(); // The updated data for this component
      this.dataSubject.next(updatedData);
    });
  }

  abstract buildAITools(): AITool[];
  abstract buildAIContext(): any;
}
